import { gql } from '@apollo/client'

const DELETE_ACTION_GOAL = gql`
  mutation deleteActionGoal($id: ID!) {
    deleteActionGoal(id: $id) {
      id
      status
    }
  }
`

export default DELETE_ACTION_GOAL
